import React, { Component } from "react";
import { Navbar, Nav, NavItem, MenuItem, Form, FormGroup, FormControl, Button, NavDropdown } from 'react-bootstrap'
import { Link, withRouter } from "react-router-dom"
import { connect } from 'react-redux'
import { fetchSearchInput, setInterval, fetchProducts } from '../actions'
var MediaQuery = require('react-responsive');
class Submenu extends Component {

    goToHomepage() {
        this.props.fetchSearchInput('')
        this.props.fetchProducts('')
        this.props.history.push('/')
    }

    goToCategories() {
        this.props.fetchSearchInput('categories')
        this.props.fetchProducts('categories')
        this.props.history.push('/search/categories')
    }

    render() {
        return (
            <Navbar
                className="mobileheader hidden-xs"
                history={this.props.history}
                style={{
                    marginBottom: 0 + 'px !important',
                    borderRadius: 0,
                    position: 'fixed',
                    backgroundColor: '#233268 !important',
                    border:'solid 1px #233268 !important',
                    height: 54 + 'px !important',
                    top: 10,
                    left: 0,
                    right: 0,
                    zIndex: 1020,
                    float: 'none',
                    padding: '5px'
                }}>
                <Navbar.Header>
                    <Navbar.Toggle style={{ marginTop: 0, padding: 3, right: 10, }} />
                    {/* <div className="hidden-lg hidden-md hidden-sm" style={{ color: 'white', fontSize: 16, marginLeft: 10 }}>เมนู</div> */}
                </Navbar.Header>
                <Navbar.Collapse className="text-center">
                    <Nav>
                        <NavItem eventKey={1} onClick={() => { this.goToHomepage() }}><div className="white-text-navbar"><span className="fa fa-home" aria-hidden="true"></span> หน้าแรก</div></NavItem>
                        <NavItem eventKey={2} onClick={() => { this.goToCategories(); window.fbq('trackCustom', 'ViewAll-1'); }}><div className="white-text-navbar"><span className="fa fa-shopping-basket" aria-hidden="true"></span> สินค้า</div></NavItem>
                        <NavItem eventKey={8} onClick={() => { this.props.history.push('/blog/all') }}><div className="white-text-navbar"><span className="fa fa-book" aria-hidden="true"></span> บทความ</div></NavItem>
                        <NavItem eventKey={3} onClick={() => { this.props.history.push('/faq') }}><div className="white-text-navbar"><span className="fa fa-question-circle" aria-hidden="true"></span> คำถามที่พบบ่อย</div></NavItem>
                        <NavItem eventKey={4} onClick={() => { this.props.history.push('/aboutus') }}><div className="white-text-navbar"><span className="fa fa-thumbs-o-up" aria-hidden="true"></span> เกี่ยวกับเรา</div></NavItem>
                        <NavItem eventKey={5} onClick={() => { this.props.history.push('/contactus') }}><div className="white-text-navbar"><span className="fa fa-envelope-o" aria-hidden="true"></span> ติดต่อเรา</div></NavItem>
                        <NavItem eventKey={6} onClick={() => { this.props.history.push('/terms_of_service') }}><div className="white-text-navbar"><span className="fa fa-file-text-o" aria-hidden="true"></span> เงื่อนไขการให้บริการ</div></NavItem>
                        <NavItem eventKey={7} onClick={() => { this.props.history.push('/business_solution') }}><div className="white-text-navbar"><span className="fa fa-file-text-o" aria-hidden="true"></span> ลูกค้าธุรกิจ</div></NavItem>
                    </Nav>
                </Navbar.Collapse>
                <h5 className='hidden-sm hidden-md hidden-lg' style={{ color: 'white!important', position: 'absolute', top: 17, left: 20, fontSize: '90%' }}>คลิกที่นี่เพื่อเปิดเมนู</h5>
            </Navbar>
        )
    }
}

function mapStateToProps(state) {
    return { searchinput: state.searchinput };
}

export default connect(null, { fetchSearchInput, setInterval, fetchProducts })(Submenu)



// WEBPACK FOOTER //
// ./src/components/submenu.js